<div *ngIf="!loading"
    class="fixed w-full h-full inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-30 gap-4 overflow-y-auto"
    (click)="$event.preventDefault(); handleCloseEditPlan();"
>
    <div class="w-full max-h-full max-w-screen-md flex flex-row gap-1 justify-center overflow-y-auto" (click)="$event.stopPropagation()">
        <div class="w-full h-full overfow-y-auto flex min-w-full bg-white p-10 rounded-md text-center shadow-lg overflow-y-auto">
            <form 
                (ngSubmit)="$event.preventDefault(); savePlan();"
                [formGroup]="editPlanForm"
                class="w-full flex flex-col items-center justify-start gap-4"
            >
                <div class="w-full flex flex-col gap-2 items-center justify-center pb-4 border-b border-orange-200">
                    <div class="w-full flex gap-2 items-center justify-between">                        
                        <h2 class="w-full oswald-font text-xl font-medium text-start text-nside-orange-400">
                            Please select pages that you want to include on your plan.
                        </h2>
                        <button
                            class="p-1 rounded-full hover:bg-gray-100"
                            (click)="$event.preventDefault(); handleCloseEditPlan();"
                        >
                            <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                        </button>
                    </div>
                </div>
                <div class="w-full flex items-start justify-start gap-4 pb-4 border-b border-orange-200">
                    <div class="w-full flex flex-col items-start gap-2">
                        <div class="flex items-start" *ngFor="let item of defaultEopSections">
                            <input noEmoji 
                                type="checkbox"
                                [id]="'section_' + item.section_id"
                                [checked]="(editPlanForm.get('selected_sections')?.value ?? []).includes(item.section_id)"
                                (change)="onCheckboxChange($event, item.section_id)"
                                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2">
                            <label [for]="'page-' + item.id" class="w-full text-start ml-2 text-sm font-medium text-gray-900">{{ item.type }}</label>
                        </div>
                    </div>
                </div>
            
                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                        (click)="$event.preventDefault(); handleCloseEditPlan();"
                    >
                        Close
                    </button>
                    <button
                        type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                        [ngClass]="{
                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': editPlanForm.invalid,
                            'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': editPlanForm.valid
                        }"
                        [disabled]="editPlanForm.invalid"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>